var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"1"}},[_c('sidebar')],1),_c('v-col',{staticClass:"mt60",attrs:{"cols":"9","xl":"9"}},[_c('v-container',[_vm._t("default")],2)],1),_c('v-col',{staticClass:"mt60",attrs:{"cols":"2","xl":"2"}},[_c('v-container',{attrs:{"fluid":""}},[_c('chiffresClients')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }